import { render } from "./DynamicTable2_Stable.vue?vue&type=template&id=4eaa3dc8&scoped=true"
import script from "./DynamicTable2_Stable.vue?vue&type=script&lang=js"
export * from "./DynamicTable2_Stable.vue?vue&type=script&lang=js"

import "./DynamicTable2_Stable.vue?vue&type=style&index=0&id=4eaa3dc8&lang=scss&scoped=true"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eaa3dc8"]])

export default __exports__